import { ErrorMessage, Field } from "formik"
import classNames from "classnames";
import "./FormFieldInput.css";
import { useEffect, useRef } from "react";
import { FileUpload, FileUploadHandlerEvent } from "primereact/fileupload";

interface Props {
  name: string;
  label?: string | undefined;
  required?: boolean;
  values?: Array<any>;
  placeholder?: string;
  value?: any;
  disable?: boolean;
  accept?: string;
  errors?: any;
  onChange?: any;
  setFieldValue?: any;
  chooseOptions?: any;
  customUpload?: any;
  type?: "file";
  refe?: any;
}

const FormFieldFileChooser = ({
  name,
  label,
  required,
  placeholder,
  value,
  disable=false,
  accept,
  errors,
  onChange,
  setFieldValue,
  chooseOptions,
  customUpload,
  type = "file",
  refe} : Props) => {
  
  useEffect(() => {
    if(setFieldValue) setFieldValue(name, value);
  }, []);
  
  return (
    <div className="d-block w-100 form-field col-12 mt-0 p-0">
      {label && <label className="form-label mb-2 w-100" htmlFor={name} >{label} {required && <span className=" text-danger">*</span>}</label>}
      
      <div className={classNames("w-100")}>
        <FileUpload name={name} 
              customUpload  
              // uploadHandler={onChange} 
              onSelect={onChange} 
              url={'/api/upload'}  
              accept={accept} 
              ref={refe}
              chooseOptions={chooseOptions}
        />
        <div className="span field-error"> 
          { errors[name] }
          {/* <ErrorMessage name={name}/> */}
        </div>
      </div>
    </div>
  )
}

export default FormFieldFileChooser;